import { COLORS } from "assets/styles/colors";

import * as S from "./styled";

export const Loader = ({ size = 20, color = COLORS.green }) => (
  <S.Container>
    <S.Loader color={color} size={size} />
  </S.Container>
);
